// extracted by mini-css-extract-plugin
module.exports = {"container":"Rights_container__bmcLz"};